import React, { useState } from 'react'
import SearchableDropdown from '@/Components/Common/SearchableDropdown'
import MultipleSelector from '@/Components/Common/MultipleSelector'
import DatePicker from '@/Components/Common/DatePicker'
import { Input } from '@/Components/ui/input'
import { Textarea } from '../ui/textarea'
import SearchableDropdownWithOptions from './SearchableDropdownWithOptions'
import Constant from '@/utils/Constant'
import { format } from 'date-fns'

const CustomFields = ({ type, label = '', options = [], placeholder = '', handleOnChange, value = '', className = '', disabled = false }) => {
    
   
    if(type=="DatePicker"&&value.length>0){
        value=value[0]
    }

    return (
        <>
            {['SinglePickList', 'Select'].includes(type) && (
                <SearchableDropdownWithOptions
                    options={options}
                    label={label}
                    selectedVal={value}
                    handleChange={(val) => {
                        handleOnChange(val)
                    }}
                    placeholder={placeholder}
                    field=""
                    className={className}
                />
            )}
            {['MultiplePickList'].includes(type) && (
                <MultipleSelector
                    disabled={disabled}
                    items={options}
                    onChange={(val) => {
                        handleOnChange(val)
                        console.log('val', val)
                    }}
                    selectedValue={value ? value : []}
                    label={label}
                    className="outline-none ring-0 focus-visible:ring-0 border-none shadow-none w-full focus:shadow-none hover:bg-transparent rounded-none"
                />
            )}
            {['DatePicker'].includes(type) && (
                <DatePicker
                date={value}
                handleChange={handleOnChange}
                mode="single"
                type="oasis"
                disabled={disabled}
                className={
                    'outline-none ring-0 focus-visible:ring-0 border-none shadow-none w-full focus:shadow-none  hover:bg-transparent rounded-none h-auto bg-transparent' +
                    className
                }
            />
            )}
            {['Text'].includes(type) && (
                <Input
                    onChange={(e) => handleOnChange(e.target.value)}
                    disabled={disabled}
                    value={value}
                    className="outline-none ring-0 focus-visible:ring-0 border-none shadow-none w-full focus:shadow-none h-full"
                />
            )}
            {['Small Text'].includes(type) && (
                <Textarea
                    disabled={disabled}
                    onChange={(e) => handleOnChange(e.target.value)}
                    value={value}
                    className="outline-none ring-0 focus-visible:ring-0 flex justify-start items-center align-middle resize-none border-none shadow-none w-full focus:shadow-none h-full"
                />
            )}
            {['Number', 'Int', 'Float'].includes(type) && (
                <Input
                    disabled={disabled}
                    onChange={(e) => handleOnChange(e.target.value)}
                    value={value}
                    type="number"
                    className="outline-none ring-0 focus-visible:ring-0 border-none shadow-none focus:shadow-none w-full h-fit"
                />
            )}
            {['blank'].includes(type) && <div className="py-2">{value}</div>}
        </>
    )
}

export default CustomFields
